import Styles from './synchrony-error.module.scss';
import {
  SynchronyErrorMessage,
  ProgressiveConfiguration,
} from '~/gql/__generated__/types';
import ProgressiveLearnMoreLink from '~/components/progressive-learn-more-link';

interface SynchronyErrorProps {
  errorConfig: SynchronyErrorMessage | null;
  progressiveConfigs?: ProgressiveConfiguration;
}

export default function SynchronyError({
  errorConfig,
  progressiveConfigs,
}: SynchronyErrorProps) {
  if (!errorConfig) return null;

  const showLearnMoreLink = errorConfig.showProgressiveLearnMoreLink;
  const linkText = errorConfig.progressiveLinkText || 'Learn More';

  return (
    <div className={Styles.errorWrapper} role="alert" tabIndex={0}>
      {errorConfig.errorHeading && (
        <h4 className={Styles.errorHeading}>{errorConfig.errorHeading}</h4>
      )}
      {errorConfig.errorMessage && (
        <div
          className={Styles.errorMessage}
          dangerouslySetInnerHTML={{ __html: errorConfig.errorMessage }}
        />
      )}
      {showLearnMoreLink && progressiveConfigs && (
        <ProgressiveLearnMoreLink
          linkText={linkText}
          progressiveConfigs={progressiveConfigs}
        />
      )}
    </div>
  );
}
